"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageTypes = exports.LINK_MESSAGE_TYPE = void 0;
exports.LINK_MESSAGE_TYPE = 'imx-link';
exports.messageTypes = {
    inProgress: 'inProgress',
    success: 'success',
    fail: 'fail',
    result: 'result',
    close: 'close',
};
